export class UserSettings{
    sendNotification:boolean;
    showInRankings:boolean;
    playerLocale:string;
    rules:string;
    
    constructor(sendNotification:boolean, showInRankings:boolean, playerLocale:string, rules:string)
    {
        this.sendNotification = sendNotification;
        this.playerLocale = playerLocale;
        this.showInRankings = showInRankings;
        this.rules = rules;
    }

    
}